import PropTypes from 'prop-types'
import InputLabel from '../ui/InputLabel'

const IndicarProducto = ({ value, onChange }) => {
  return (
    <InputLabel
      name="titulo"
      value={value}
      onChange={onChange}
      label=" Tené en cuenta que no podrás editarlo"
      classNameLabel="lbl descripcion-cuadro-publicacion"
      classNameInput="titulo-publicacion"
      placeholder="Ej: TV/Monitor Samsung LED 35' FullHD"
    />
  )
}

IndicarProducto.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default IndicarProducto
